import FORM_TYPE from '../../../../constants/FormType';
import FORM_AUDIENCE_TYPE from '../../../../constants/FormAudienceType';

export const LINKED_EMPLOYEE_AUDIENCE = 'employee-linked-to-student';
export const LINKED_EMPLOYEE_TO_EMPLOYEE_AUDIENCE = 'employee-linked-to-employee';

export const isLinkedToStudentSelfServiceForm = ({formType, audienceValue}) =>
    formType === FORM_TYPE.selfService && audienceValue === LINKED_EMPLOYEE_AUDIENCE;

export const shouldShowContactPriority = ({audience, formType, audienceValue}) =>
    audience === FORM_AUDIENCE_TYPE.parentsForChildCompletion ||
    isLinkedToStudentSelfServiceForm({
        formType,
        audienceValue
    });

export const contactPriorityQuestion = ({isCommunicationMode, formType, audienceValue}) => {
    if (isCommunicationMode) {
        return 'Who should receive this email?';
    }

    return isLinkedToStudentSelfServiceForm({
        formType,
        audienceValue
    })
        ? 'Who should receive the emails sent to the linked student\'s parents?'
        : 'Who should receive this form?';
};
